
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.pricing-tier-card {
  background-color: $white;
  display: flex;
  flex-direction: column;
  max-width: 395px;
  width: 100%;

  &__title {
    font-weight: bold;
  }

  &__price-for-period-subtext {
    height: 17px;

    &--compact {
      height: auto;
    }
  }

  &--font-normal {
    font-weight: normal;
  }

  &--block {
    display: block;
  }

  &__badge-wrapper {
    height: 45px;
    margin-top: -5px;

    &--hide-on-mobile {
      display: none;

      @media (min-width: 665px) {
        display: block;
      }
    }
  }

  &__badge {
    align-content: center;
    background-color: $tangerine;
    display: inline-flex;
    padding: 6px 12px;
    border-radius: 20px;
  }

  &__badge-icon {
    height: 16px;
    width: 16px;
    margin-right: 6px;
  }

  &__header-icon {
    width: 60px;
    &--small {
      width: 48px;
    }
  }

  &__section {
    padding: 22px 28px 10px 28px;

    &:first-child {
      @include media-query(tablet) {
        border-bottom: 2px solid $stone;
        min-height: 340px;
      }

      > * {
        padding-bottom: 20px;
      }
    }

    @include media-query(tablet) {
      &--compact:first-child {
        min-height: 280px;

        > * {
          padding-bottom: 16px;
        }
      }
    }

    &:last-child {
      flex-grow: 1;
    }

    &--hidden {
      display: none;

      @include media-query(tablet) {
        display: flex;
        flex-direction: column;
      }
    }

    &--space-between {
      justify-content: space-between;
    }
  }

  &__category {
    padding-bottom: 0 !important;
  }

  &__description {
    height: 75px;
    max-width: 520px;

    &--compact {
      height: auto;
      min-height: 75px;
    }

    @include media-query(tablet) {
      &--compact {
        min-height: auto;
      }
    }
  }

  &__cta--show-on-mobile {
    @media (min-width: 665px) {
      display: none;
    }
  }

  &__cta--bottom .cta-link__arrow {
    display: none;
  }

  &__cta--top {
    display: none;
    @media (min-width: 665px) {
      display: block;
      float: right;
      min-width: 200px;
    }
  }

  &__price-for-period {
    &--dollar-amount {
      font-weight: bold;
    }
  }

  &__pricing-modal-button {
    border-bottom: 1px solid $slate;

    &:hover {
      cursor: pointer;
    }
  }

  &__features {
    &--with-columns {
      display: flex;
      flex-direction: column;

      @include media-query(tablet) {
        flex-direction: row;
      }
    }
  }

  &__features-column {
    @include media-query(tablet) {
      width: 50%;
    }
  }

  &__features-toggle {
    outline: none;

    span {
      margin-left: 7px;
      padding-bottom: 4px;
      border-bottom: 1px solid $black-legacy;
    }

    @include media-query(tablet) {
      display: none;
    }
  }

  &__features-toggle-arrow {
    &--rotate {
      transform: rotate(90deg);
    }
  }

  &__features-title {
    padding-bottom: 16px;
  }

  &__features-list-item {
    list-style: disc;
    padding-bottom: 0.5rem;
    margin-left: 20px;

    &--no-checkmark {
      list-style-type: none;
      margin-left: 0;
    }

    &--no-checkmark:not(:first-child) {
      margin-top: 16px;
    }

    &--double-column {
      max-width: 300px;
    }

    &--first-in-group {
      margin-top: 28px;

      &:first-child {
        margin-top: 0;
      }
    }
  }

  &__features-modal {
    margin-bottom: 20px;
    padding-top: 48px;

    &--center {
      align-self: center;
      font-weight: 600;
    }
  }

  &__show-on-desktop {
    display: none;

    @media (min-width: 1270px) {
      display: block;
    }
  }

  &__hide-on-desktop {
    @media (min-width: 1270px) {
      display: none;
    }
  }
}

.pricing-tier-card.pricing-tier-card {
  &--rounded {
    border-radius: 6px;
  }

  &--large {
    max-width: 820px;
  }
}
`